import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const CheckboxCheckedIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect width="24" height="24" rx="4" fill="#311E86" />
      <path
        d="M5.5 13L8 15.5L15 8.5"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        fill="none"
      />
      <path
        d="M9 13L11.5 15.5L18.5 8.5"
        stroke="#311E86"
        strokeWidth="3.2"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        fill="none"
      />
      <path
        d="M9 13L11.5 15.5L18.5 8.5"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        fill="none"
      />
    </SvgIcon>
  );
};

export const CheckboxUncheckedIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#BBBBBB"
        strokeWidth="1"
      />
    </SvgIcon>
  );
};
